module.exports = __webpack_public_path__ + "img/olympiacos-fc.bf1e7515.png";